import React, {useEffect, useRef, useState} from "react";
import axios from 'axios';

// DXC-12146, 장애 문의처 전화번호 변경 (DXC-12043 의 서버시각 전환 게이트 재사용)
//   2026-10-30 16:59:59 (JST) 까지 구 번호, 2026-10-30 17:00:00 (JST) 부터 신 번호를 노출한다.
//   기준시각은 PC 시계가 아니라 서버 시각을 쓴다. 단 공지 API(rc.checkeyedx.com) 는 크로스 오리진이고
//   Access-Control-Expose-Headers 가 없어 Date 를 읽을 수 없으므로(안전목록 헤더가 아니다),
//   같은 오리진인 자기 자신을 HEAD 로 찔러 Date 를 읽는다. CloudFront 캐시 히트 시 Date 가
//   캐시된 시점이라 낡으므로 Age(경과 초) 를 더해 보정한다.
const TEL_CUTOVER_JST = 20261030170000;          // YYYYMMDDHHmmss (JST)
const TEL_BEFORE      = "03-5287-5010";
const TEL_AFTER       = "050-1794-2212";

const NotificationComponent = () => {
    const [notifications, setNotifications] = useState([]);
    const [serverJst, setServerJst] = useState(null);   // 서버 시각(JST) 미확정이면 null

    useEffect(() => {
    //fetch("http://localhost:8080/owl/cmi1000e.mics?mode=doGetNotification&value1=OWL&value2=RC-LS")
    //let URL = "https://owl-sys-beta.owl-developer.net/owl/cmi1000e.mics?mode=doNotificationList";   // RC-LS
    let URL = "https://rc.checkeyedx.com/owl/cmi1000e.mics?mode=doNotificationList"; // Checkeye-DX
    // let URL = "http://localhost:8085/owl/cmi1000e.mics?mode=doNotificationList";   // LOCAL-TEST

        // DXC-12043, 서버 시각 확보 — 같은 오리진이라 Date/Age 를 제한 없이 읽을 수 있다
        fetch("/index.html", { method: "HEAD", cache: "no-store" })
            .then((response) => {
                const svrDate = response.headers.get("date");
                const age = parseInt(response.headers.get("age") || "0", 10);
                const jst = toJstNumber(svrDate, isNaN(age) ? 0 : age);
                if (jst !== null) setServerJst(jst);
            })
            .catch(() => { /* 미확정 유지 -> 신 번호 노출 */ });

        console.log("FETCH URL : " + URL);
        fetch(URL)
            .then((response) => response.json())
            .then((data) => {
                console.log("notice data : " + data.LIST[0].content);
                const notificationsWithExpandedState = data.LIST.map((item) => ({
                    ...item,
                    expanded: false, // 각 항목에 expanded 상태 추가
                }));
                setNotifications(notificationsWithExpandedState || []);
            })
            .catch(() => {
                setNotifications([]);
            });
    }, []); // 빈 배열을 두 번째 인자로 전달하여 컴포넌트가 처음 렌더링될 때만 실행되도록 설정

    const toggleExpand = (index) => {
        const updatedNotifications = [...notifications];
        updatedNotifications[index].expanded = !updatedNotifications[index].expanded;
        setNotifications(updatedNotifications);
    };

    // DXC-12043, 서버 시각 미확정(조회 실패 등) 이면 신 번호를 노출 — 이전 후 구 번호 노출이 더 큰 피해이므로
    const telNo = (serverJst !== null && serverJst < TEL_CUTOVER_JST) ? TEL_BEFORE : TEL_AFTER;

    return (
        <div className="notice-body">
            <div style={{ width: '100%', alignContent: 'left', marginLeft: '8px' }}>
                <table ><tr><td rowSpan={2}
                                 style={{ backgroundColor: '#A4C8F0', width: '5px' }}></td>
                <td className="notice-sub-title">&nbsp;&nbsp;&nbsp;Information</td></tr>
            <tr><td className="notice-title">&nbsp;お知らせ</td></tr></table></div>
            <div className="wrap">
                <table className="custom-table">
                    <tbody>
                    {notifications.map((item, index) => {
                        const startDtFormat = "■" +
                            item.start_dt.substring(2, 4) +
                            "/" +
                            item.start_dt.substring(4, 6) +
                            "/" +
                            item.start_dt.substring(6, 8);

                        if ( chkDateTime( item.start_dt, item.end_dt ) ) {
                            return (
                                <tr key={index}>
                                    <th>{startDtFormat}</th>
                                    {/*<td*/}
                                    {/*    className={`content-cell ${item.expanded ? "expanded" : ""}`}*/}
                                    {/*    onClick={() => toggleExpand(index)}*/}
                                    {/*>*/}
                                    {/*    /!* 컨텐츠가 유효한 HTML인 경우에만 dangerouslySetInnerHTML 사용 *!/*/}
                                    {/*    {item.content ? (*/}
                                    {/*        <div dangerouslySetInnerHTML={{ __html: item.content }} />*/}
                                    {/*    ) : (*/}
                                    {/*        <div>No content available</div> // 컨텐츠가 없을 경우 대체 텍스트*/}
                                    {/*    )}*/}
                                    {/*    {!item.expanded && (*/}
                                    {/*        <span className="toggle-btn">[続きを読む]</span>*/}
                                    {/*    )}*/}
                                    {/*    {item.expanded && (*/}
                                    {/*        <span className="toggle-btn">[閉じる]</span>*/}
                                    {/*    )}*/}
                                    {/*</td>*/}
                                    <ExpandableRow key={index} date={startDtFormat} content={item.content}/>
                                </tr>
                            );
                        } else {
                            console.log(" date chk "+ item.start_dt);
                        }
                    })}
                    </tbody>
                </table>
            </div>

            <div className="wrap2">
                <div className="box">
                    <div className="in">
                        <h4 className="center_text">～操作方法や点検内容についてお困りの場合は～<br/><br/>
                            チェックアイDX　お問合せフォーム<br/>
                            &nbsp;&nbsp; （ログイン後、画面右上の &nbsp;<img style={{height: 1 + 'em'}}  src="supportDesk.png"/>　のアイコンから）<br/>
                            または　E-Mail : checkeye-dx@nichiigakkan.co.jp<br/>
                            <br/><br/>
                            ～システム障害の場合は～<br/>
                            TEL：{telNo}　平日10時～17時<br/>
                            （土日・祝祭日・夏季冬季休業期間を除く）
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    );
};



function ExpandableRow({ date, content }) {
    const [isExpandable, setIsExpandable] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            const lineHeight = parseInt(window.getComputedStyle(contentRef.current).lineHeight);
            const maxHeight = lineHeight * 3; // 3줄 기준 높이
            if (contentRef.current.scrollHeight > maxHeight) {
                setIsExpandable(true);
            }
        }
    }, []);

    return (
            <td className={`content-cell ${isExpanded ? "expanded" : ""}`} ref={contentRef}>
                <div dangerouslySetInnerHTML={{ __html: content }} />
                {isExpandable && (
                    <span
                        className="toggle-btn"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? "[閉じる] " : "[続きを読む] "}
                    </span>
                )}
            </td>
    );
}

//-------------------------------------------------------------
// DXC-12043, HTTP Date 헤더(GMT) + Age(초) -> JST YYYYMMDDHHmmss 숫자
//   +9h 후 getUTC* 로 읽어 브라우저 로컬 타임존과 무관하게 JST 를 얻는다.
//-------------------------------------------------------------
function toJstNumber(httpDate, ageSec) {
    if (!httpDate) return null;
    const gmt = new Date(httpDate);
    if (isNaN(gmt.getTime())) return null;
    const jst = new Date(gmt.getTime() + (ageSec || 0) * 1000 + 9 * 60 * 60 * 1000);
    const p2 = (n) => (n < 10 ? "0" + n : "" + n);
    return parseInt(
        jst.getUTCFullYear() + p2(jst.getUTCMonth() + 1) + p2(jst.getUTCDate()) +
        p2(jst.getUTCHours()) + p2(jst.getUTCMinutes()) + p2(jst.getUTCSeconds()), 10);
}

//-------------------------------------------------------------
// 공지 기간 확인
//-------------------------------------------------------------
function chkDateTime(frdt, todt ){
    console.log ( "isServerWorking ....") ;
    const today = new Date(); // 현재 날짜를 가져옵니다.
    let year = today.getFullYear(); //년도 구하기
    let month = (today.getMonth()+1);
    let day = today.getDate();
    let hour = today.getHours();
    month = month >= 10 ? month : '0' + month;
    day = day >= 10 ? day : '0' + day;
    hour = hour >= 10 ? hour : '0' + hour;
    const todayTime = year + '' + month + '' + day + '' + hour ;
    console.log ("chkDateTime -> todayTime : " +todayTime,
        ", frdt ->" + frdt +", todt :" + todt) ;
    if ( (parseInt(todayTime) >= parseInt(frdt)) && (parseInt(todayTime) <= parseInt(todt))) {
        console.log("공지 가능 시간입니다." );
        return true ;
    }else {
        console.log("공지 불가 합니다. " );
        return false ;
    }
}

export default NotificationComponent;
